export default __webpack_public_path__ + "static/media/pencil.16d140e1.svg";